export default __webpack_public_path__ + "static/media/top_w576down_2.70907927.png";